/**
 * Query keys das feature flags resolvidas (@pps/feature-flags). A resolução depende de
 * QUEM pergunta e em QUAL clube ele está agindo — os dois entram na chave.
 */
import { tuple } from "./core";

const root = ["feature-flags"] as const;

// Fora de `root` de propósito: ligar/desligar uma flag invalida `all` e não pode
// recarregar a lista de clubes do admin a cada clique.
const clubesAlvoRoot = ["feature-flags-clubes-alvo"] as const;

export const featureFlags = {
  all: root,
  resolvidas: (userId: string | null | undefined, clubId: string | null | undefined) =>
    tuple(root, "resolvidas", userId ?? null, clubId ?? null),
  /** Clubes que o admin escolhe como alvo de uma flag (pelo nome). */
  clubesAlvo: () => clubesAlvoRoot,
} as const;
